import { Avatar, Box, Card, IconButton, List, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useTranslation } from 'react-i18next';
import { HeaderBox } from './mBookListPage';
import BookIcon from '../../svg/book.svg';
import MusicNoteIcon from '../../svg/audioWithoutLyrics.svg';
import SelfImprovementIcon from '../../svg/pravachanCircle.svg';
import DescriptionIcon from '../../svg/articles.svg';
import AuthorsService from "../../Services/Authors";
import { useEffect, useState } from 'react';
import i18n from '../../i18n';
const LegendsIntroduction = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location: any = useLocation();
    const authorId = location.state?.id;
   
    const items = [
        { icon: <img src={BookIcon} height={55} width={55} onClick={()=>navigate("/books",{state:authorId})}/>, label: "E-Books"},
        { icon: <img src={MusicNoteIcon} height={55} width={55} />, label: "Audios" },
        { icon: <img src={SelfImprovementIcon} height={55} width={55} />, label: "Pravachans" },
        { icon: <img src={DescriptionIcon} height={55} width={55} />, label: "Articles" },
    ];
    const [authorContent, setAuthorContent] = useState<any>()
    useEffect(() => {
        // setRefresh(false)
        AuthorsService.getAuthorData("", 3).then((res: any) => {
            console.log("API Response:", res); // 👈 check this
            if (res) {
                setAuthorContent(res?.result?.authorContent);
            }
        });
    }, []);
    useEffect(() => {
        AuthorsService.GetAuthorDataById(authorId, "").then((res) => {
            //   showBread(res?.result?.name);
            setAuthorContent(res?.result?.authorContent)
        });
    }, [i18n.language]);
    return (
        <div className="scroll-container"
            style={{
                backgroundColor: "#F2F0EF",
                height: "100vh",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column"
            }}
        >

            {/* Fixed Header */}
            <HeaderBox>
                <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 16, top: 35, p: 0 }}>
                    <ArrowBackIosIcon sx={{ color: "white", fontSize: '18px' }} />
                </IconButton>
                <IconButton onClick={() => navigate("/")} sx={{ position: 'absolute', left: 48, top: 35, p: 0 }}>
                    <HomeOutlinedIcon sx={{ color: "white", fontSize: '24px' }} />
                </IconButton>
                <Typography variant="caption" sx={{ color: "#ffffffdd", opacity: 0.9, mb: 0.5 }}>
                    {t("shrihari_tr")}
                </Typography>
                <Typography variant="h6" sx={{ color: "#ffffffdd", opacity: 0.9, fontSize: 15 }}>
                    {t("Legends_Introduction_tr")}
                </Typography>
            </HeaderBox>

            {/* Page Content */}
            <div style={{
                width: "100%",
                padding: 8,
                paddingTop: "90px",
                paddingRight: 0,
                marginBottom: "70px",
                fontSize: "10px",
            }}>
                <div style={{ backgroundColor: "white", marginRight: -5, marginLeft: -5, marginTop: -8 }}>
                    <Typography style={{ textAlign: 'center', paddingTop: 14, fontWeight: 600, color: "#353935", fontFamily: 'chanakyaUni', fontSize: 20 }}>

                        {
                            authorId === "5bbc5fa51fd2d735b0087d34"
                                ? t("Honorable_Shri_Jayadayal_Ji")
                                : authorId === "5bbc5fcd1fd2d735b0087d35"
                                    ? t("Honorable_Shri_Hanumanprasad_ji_poddar")
                                    : authorId === "5bbc60101fd2d735b0087d36"
                                        ? t("Honorable_Swami_Shri_Ramsukhdas_Ji")
                                        : null
                        }


                    </Typography>

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            flexWrap: "wrap",
                            gap: { xs: 3, sm: 13, md: 20 },
                            mt: 1,
                        }}
                    >
                        {items.map((item, index) => (
                            <Box
                                key={index}
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    paddingBottom: 2,

                                }}
                            >
                                {/* <Avatar
                                    sx={{
                                        bgcolor: "#FF8C00",
                                        width: 43,
                                        height: 43,
                                    }}
                                > */}
                                {item.icon}
                                {/* </Avatar> */}
                                <Typography
                                    sx={{
                                        // mt: 2,
                                        fontSize: "16px",
                                        fontWeight: 500,
                                        fontFamily: 'chanakyaUni',
                                        color: "#353935",
                                    }}
                                >
                                    {item.label}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </div>
                <div className='scroll-container' style={{ backgroundColor: "white", marginRight: -5, marginLeft: -5, marginTop: 8, maxHeight: 475, overflowY: 'auto' }}>
                    <div
                        style={{
                            position: 'fixed',
                            width: "100%",
                            backgroundColor: 'white',
                            fontSize: 20,
                            paddingTop: 5,
                            paddingLeft: 5,
                            zIndex: 1
                        }}
                    >
                        {t("Introduction_tr")}
                    </div>
                    {
                        authorContent ? (
                            <div
                                style={{ padding: '10px', paddingTop: '35px', fontSize: 17 }}
                                dangerouslySetInnerHTML={{ __html: authorContent }}
                            />
                        ) : (
                            <Typography sx={{ padding: 2 }}>Loading...</Typography>
                        )
                    }
                </div>

            </div>

            {/* Fixed Footer */}
            <div
                style={{
                    width: "100%",
                    height: "40px",
                    backgroundColor: "#f97316",
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    padding: 18,
                }}
            ></div>

        </div>
    );
}

export default LegendsIntroduction;
